var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.rootClass,style:(_vm.rootStyle)},[_c('div',{staticClass:"lc-chop__content",style:(_vm.contentStyle)},[_c('chop'),_c('lc-chop-font',{attrs:{"text":_vm.text}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }